import { render } from "./diskDetectionDetail.vue?vue&type=template&id=5dd3d9b3&scoped=true"
import script from "./diskDetectionDetail.vue?vue&type=script&lang=js"
export * from "./diskDetectionDetail.vue?vue&type=script&lang=js"

import "./diskDetectionDetail.vue?vue&type=style&index=0&id=5dd3d9b3&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd3d9b3"]])

export default __exports__